import { TEditModifierAction, EditModifierActionTypes } from './editModifierActions';
import { IEditModifierState } from './editModifierContext';

export const editModifierReducer = (state: IEditModifierState, action: TEditModifierAction): IEditModifierState => {
	switch (action.type) {
		case EditModifierActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case EditModifierActionTypes.SET_ALL_DATA:
			return {
				...state,
				modifierID: action.payload.modifierID,
				type: action.payload.type,
				isCreatedOnPos: action.payload.isCreatedOnPos,
				filePath: action.payload.filePath,
				nameOfModifier: action.payload.nameOfModifier,
				description: action.payload.description,
				initialIDSelectedCustomer: action.payload.initialIDSelectedCustomer,
				posName: action.payload.posName,
				externalId: action.payload.externalId,
				articleNumber: action.payload.articleNumber,
				initialIDsSelectedRestaurant: action.payload.initialIDsSelectedRestaurant,
				hasSchedulePriority: action.payload.hasSchedulePriority,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				translations: action.payload.translations,
			};
		case EditModifierActionTypes.CHANGE_LOADER_STATUS:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case EditModifierActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case EditModifierActionTypes.DELETE_PHOTO:
			return {
				...state,
				filePath: null,
				fileId: null,
			};
		case EditModifierActionTypes.CHANGE_NAME_OF_MODIFIER:
			return {
				...state,
				nameOfModifier: action.payload.nameOfModifier,
			};
		case EditModifierActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case EditModifierActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case EditModifierActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
			};
		case EditModifierActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case EditModifierActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE:
			return {
				...state,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case EditModifierActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditModifierActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditModifierActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY:
			return {
				...state,
				hasSchedulePriority: !state.hasSchedulePriority,
			};
		case EditModifierActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditModifierActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditModifierActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditModifierActionTypes.SET_INITIAL_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case EditModifierActionTypes.SET_IDS_RESTAURANT:
			return {
				...state,
				IDsSelectedRestaurant: action.payload.IDsSelectedRestaurant,
			};
		case EditModifierActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditModifierActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
